import type { TouchEvent } from 'react';
import { ArrowLeft, Home } from 'lucide-react';
import { useLanguage } from '@/contexts/LanguageContext';

interface KioskBottomBarProps {
  onHome: () => void;
  onBack: () => void;
  backLabel?: string;
  homeLabel?: string;
}

export const KioskBottomBar = ({
  onHome,
  onBack,
  backLabel,
  homeLabel,
}: KioskBottomBarProps) => {
  const { t } = useLanguage();
  const resolvedBackLabel = backLabel ?? t('common.back');
  const resolvedHomeLabel = homeLabel ?? t('common.home');
  const handleTouch = (event: TouchEvent<HTMLButtonElement>, action: () => void) => {
    event.preventDefault();
    action();
  };

  return (
    <nav className="kiosk-bottom-bar" aria-label="Navegación del tótem">
      <button
        className="kiosk-bottom-bar-back"
        onClick={onBack}
        onTouchEnd={(event) => handleTouch(event, onBack)}
        type="button"
        aria-label={resolvedBackLabel}
        title={resolvedBackLabel}
      >
        <ArrowLeft />
      </button>

      <button
        className="kiosk-bottom-bar-home"
        onClick={onHome}
        onTouchEnd={(event) => handleTouch(event, onHome)}
        type="button"
        aria-label={resolvedHomeLabel}
        title={resolvedHomeLabel}
      >
        <Home />
      </button>
    </nav>
  );
};
